module.exports = __webpack_public_path__ + "img/ic-delete.b85a6f1c.svg";